"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.entityGrantedPersonField = exports.entityLinkedSelectParentField = exports.entityVisibilitySelectField = exports.entityLinkedSelectField = void 0;
var react_1 = __importDefault(require("react"));
var input_entity_select_1 = require("../components/forms/input-entity-select");
var sprintf_js_1 = require("sprintf-js");
var pluralize_1 = require("pluralize");
var entity_field_1 = require("./entity-field");
var entityLinkedSelectField = function (args) {
  var name = args.name,
    placeholder = args.placeholder,
    required = args.required,
    _a = args.isClearable,
    isClearable = _a === void 0 ? true : _a,
    label = args.label,
    description = args.description,
    entityTypeName = args.entityTypeName,
    context = args.context,
    isAvailable = args.isAvailable,
    loadOptionsFilter = args.loadOptionsFilter,
    variant = args.variant,
    _b = args.fieldSet,
    fieldSet = _b === void 0 ? 'overview' : _b;
  var isMulti = args.isMulti === undefined ? (0, pluralize_1.isPlural)(name) : args.isMulti;
  var focus = !!args.focus;
  var entities = context.entities,
    t = context.t,
    definition = context.definition;
  var selectEntityDefinition = entities[entityTypeName];
  if (!selectEntityDefinition) {
    return null;
  }
  var currentUserCan = context.currentUserCan;
  var notRequiredMultiLabel = (0, sprintf_js_1.sprintf)(t("Does this %s have any associated %s?"), definition.label, selectEntityDefinition.pluralLabel);
  var requiredMultiLabel = (0, sprintf_js_1.sprintf)(t("Which %s are associated with this %s?"), selectEntityDefinition.pluralLabel, definition.label);
  var notRequiredLabel = (0, sprintf_js_1.sprintf)(t("Is there %s associated with this %s?"), selectEntityDefinition.aLabel, definition.label);
  var requiredLabel = (0, sprintf_js_1.sprintf)(t("Which %s is associated with this %s?"), selectEntityDefinition.label, definition.label);
  // by default, prevent sub-forms of the same type, which currently causes infinite recursion (need to investigate why this is)
  // need to check this directly now, as it causes React hook errors if it's delay-called.
  var checkCanCreate = selectEntityDefinition.select.canCreate({
    currentUserCan: currentUserCan
  });
  var canCreate = args.canCreate || function () {
    return entityTypeName !== context.entityTypeName && checkCanCreate;
  };
  // // console.log(variant, entityTypeName);
  if (variant && context.metadata && context.metadata.variant !== variant) {
    return null;
  }
  // if (name === "pages") {
  //   console.log("ENTITY LINKED SELECT CONTEXT", name, context);
  // }
  var isOptionDisabled = args.isOptionDisabled && args.isOptionDisabled(context);
  return __assign(__assign({}, (0, entity_field_1.entityFieldArgs)(args)), {
    placeholder: placeholder && t(placeholder) || selectEntityDefinition && (isMulti ? (0, sprintf_js_1.sprintf)(t("Find one or more %s"), selectEntityDefinition.pluralLabel) : (0, sprintf_js_1.sprintf)(t("Find %s"), selectEntityDefinition.aLabel)),
    label: label && t(label) || selectEntityDefinition && (isMulti ? t(selectEntityDefinition.pluralLabel) : t(selectEntityDefinition.label)),
    description: description && t(description) || selectEntityDefinition && (isMulti ? required ? requiredMultiLabel : notRequiredMultiLabel : required ? requiredLabel : notRequiredLabel),
    render: function (props) {
      return react_1.default.createElement(input_entity_select_1.InputEntitySelect, __assign({}, props, {
        canCreate: canCreate,
        isOptionDisabled: isOptionDisabled,
        isClearable: isClearable,
        isMulti: isMulti,
        loadOptionsFilter: loadOptionsFilter,
        context: context,
        entityTypeName: entityTypeName
      }));
    }
  });
};
exports.entityLinkedSelectField = entityLinkedSelectField;
var entityVisibilitySelectField = function (args) {
  var context = args.context;
  var t = context.t,
    definition = context.definition;
  return (0, exports.entityLinkedSelectField)(__assign(__assign({
    fieldSet: 'admin',
    description: (0, sprintf_js_1.sprintf)(t('Specify any special platform visibility for this %s'), definition.label)
  }, args), {
    name: 'visibility',
    entityTypeName: 'Visibility',
    placeholder: t('Default (Visible)')
  }));
};
exports.entityVisibilitySelectField = entityVisibilitySelectField;
var entityLinkedSelectParentField = function (args) {
  var context = args.context,
    rest = __rest(args, ["context"]);
  var t = context.t,
    entities = context.entities,
    entityTypeName = context.entityTypeName;
  var selectEntityDefinition = entities[entityTypeName];
  var isOptionDisabled = function (context) {
    return function (option) {
      var id = context.entityData.id;
      return option.value === id;
    };
  };
  return (0, exports.entityLinkedSelectField)(__assign(__assign({
    fieldSet: 'overview',
    isOptionDisabled: isOptionDisabled
  }, args), {
    entityTypeName: args.entityTypeName === undefined ? entityTypeName : args.entityTypeName,
    label: (0, sprintf_js_1.sprintf)(t("Parent %s"), selectEntityDefinition.label),
    description: (0, sprintf_js_1.sprintf)(t('Does this %s have a parent %1$s?'), selectEntityDefinition.label),
    name: 'parent' || args.name,
    canCreate: function () {
      return false;
    }
  }));
};
exports.entityLinkedSelectParentField = entityLinkedSelectParentField;
var entityGrantedPersonField = function (args) {
  var context = args.context;
  var metadata = context.metadata;
  var variant = metadata.variant;
  if (variant === 'forPerson') {
    return null;
  }
  return (0, exports.entityLinkedSelectField)(__assign(__assign({}, args), {
    canCreate: function () {
      return false;
    },
    loadOptionsFilter: function (inputValue) {
      return {
        _optionLabel: {
          contains: inputValue
        },
        hasAccount: {
          is: true
        }
      };
    },
    required: true,
    name: args.name || 'grantedPerson',
    entityTypeName: 'Person'
  }));
};
exports.entityGrantedPersonField = entityGrantedPersonField;